export default __webpack_public_path__ + "static/media/mxnet.aec9aa47.svg";